import { Driver } from "../../types/driver.types";
import { DUMMY_DRIVER } from "./types";

export const removeUnnecessaryFields = (
  driver: Driver | null
): Omit<Driver, "_id" | "password"> => {
  if (!driver) return DUMMY_DRIVER;
  const { _id, password, ...cleanedDriver } = driver;
  return {
    ...cleanedDriver,
    birthDate:
      cleanedDriver.birthDate instanceof Date
        ? cleanedDriver.birthDate
        : new Date(cleanedDriver.birthDate),
    creationDate:
      cleanedDriver.creationDate instanceof Date
        ? cleanedDriver.creationDate
        : new Date(cleanedDriver.creationDate),
  };
};

export const cleanDriverData = (data: Partial<Driver>): Partial<Driver> => {
  const allowedFields: (keyof Driver)[] = [
    "drivingLicenseNumber",
    "drivingLicenseType",
    "name",
    "lastName",
    "email",
    "phone",
    "civility",
    "birthDate",
    "manuallyActive",
    "transporter",
    "creationDate",
    "selectedChapters", // Added selectedChapters to allowed fields
  ];

  return Object.fromEntries(
    Object.entries(data).filter(([key]) =>
      allowedFields.includes(key as keyof Driver)
    )
  ) as Partial<Driver>;
};
